import { useQuery } from '@tanstack/react-query';
import { publicApi } from '../../../api/api';

/**
 * Custom hook 훅 untuk mengambil data skin dari API.
 * @param {string} targetUrl - URL dari skin yang ingin diambil datanya.
 * @returns {object} - Objek hasil dari useQuery (data, isLoading, isError, dll).
 */
export interface SkinData {
    id: string | null;
    name: string | null;
    address: string | null;
    email: string | null;
    phone: string | null;
    logo: string | null;
    cover_image: string | null;
    url: string | null;
    color: string | null;
    additional: any | null; // Ganti dengan tipe yang sesuai jika ada
    logo_url: string | null;
    cover_image_url: string | null;
    favicon_url: string | null;
}

interface SkinResponse {
    data: SkinData;
    code: number;
    message: string;
    success: boolean;
}

interface UseSkinDataResult {
    data?: SkinResponse;
    isLoading: boolean;
    isError: boolean;
    // Add other fields from useQuery result as needed
}

export const useSkinData = (targetUrl: string): UseSkinDataResult => {
    return useQuery<SkinData, Error>({
        // Key query-nya dinamis berdasarkan targetUrl
        queryKey: ['skin', targetUrl],

        // Fungsi untuk mengambil data
        queryFn: async () => {
            const response = await publicApi.get<SkinData>('v4/skin', {
                params: {
                    url: targetUrl,
                },
            });
            return response.data;
        },

        // ✅ Praktik terbaik: Nonaktifkan query jika targetUrl tidak ada.
        //    Ini mencegah request API yang tidak perlu.
        enabled: !!targetUrl,
    }) as UseSkinDataResult;
};